import axios from 'axios'

export const HttpRequest = {
  get: (url, options?) => {
    if (options) return axios.get(url, ...options)
    else return axios.get(url)
  }
}

export default HttpRequest



// WEBPACK FOOTER //
// ./src/api/HttpRequest.ts